// French

const lang = {
  gateMediaPreviewHeader: 'Vous aimerez aussi',
  loadmore: 'Voir plus',
  nextMedia: 'Média suivant',
  previousMedia: 'Médias précédents',
  closePost: 'Fermer la publication',
  nextPost: 'Publication suivante',
  previousPost: 'Publication précédente',
  outOfStock: 'En rupture de stock',
  numberOfReviews() {
    return 'avis'
  },
  reportFormField: 'Veuillez saisir un message',
  reportPost: 'Signaler la publication',
  reportFormTitle: 'Souhaitez-vous signaler ce contenu ?',
  reportFormDetails:
    'Si vous considérez ce contenu comme inapproprié, indésirable ou portant atteinte aux droits individuels, vous pouvez le signaler ci-dessous. Si vous signalez ce contenu, les modérateurs en charge de ce contenu seront automatiquement notifiés et prendront les mesures nécessaires.',
  reportFormMessagePlaceholder: 'Indiquez la raison de votre signalement',
  reportFormMessageLabel: 'Votre message',
  reportFormEmailLabel: 'Votre email',
  reportFormSubmitButtonText: 'Envoyer un rapport',
  reportFormCancelButtonText: 'Annuler',
  reportFormSentTitle: 'Merci pour votre rapport !',
  reportFormSentCloseButtonText: 'Fermer',
  cardAndTileAriaLabel:
    'Liste des publications provenant de comptes sur diverses plateformes sociales',
  carouselAriaLabel:
    'Carrousel avec des publications provenant de comptes sur diverses plateformes sociales',
  singleAriaLabel: 'Ci-dessous, une publication d’un compte d’un réseau social',
  poweredBy: 'Proposé par Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` publiée à ${date}` : ''
    const createdByString = userName ? ` de ${userName}` : ''
    return `Photo${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Téléchargez vos médias',
  openTheGate: 'Ouvrir la boîte de dialogue',
  gridRoleDescription: 'grille',
  carouselRoleDescription: 'carrousel',
  tiktokVideoAriaLabel: 'Vidéo TikTok intégrée. Appuyez sur lecture pour voir le contenu.',
  feedThumbnailAriaLabel: (postIndex, maxPosts) =>
    `Vignette du média ${postIndex + 1} sur ${maxPosts}, ouvre une fenêtre avec le contenu des réseaux sociaux et une liste de produits mis en avant.`,
  carouselControlButtonsAriaLabel: 'Boutons de contrôle du carrousel',
  gateCarouselIndicatorAriaLabel: (mediaIndex, maxMedia) =>
    `Média ${mediaIndex + 1} sur ${maxMedia}`,
  showMoreCaption: 'Afficher plus de légende',
  showLessCaption: 'Afficher moins de légende',
  originalPrice: (price) => `Prix original : ${price}`,
  salesPrice: (price) => `Prix promotionnel : ${price}`,
  postPublishedBy: 'Publication publiée par',
  mediaAltText: (isVideo, username, date, altText) => {
    const mediaType = isVideo ? 'Vidéo' : 'Image'
    const user = username ? `${username}` : 'utilisateur inconnu'
    const publishDate = date ? `le ${date}` : ''
    return `${mediaType} publiée par ${user} ${publishDate}. Cela peut être ${altText}`
  },
  gateSlideAriaLabel: (postIndex, maxPosts) => `Publication ${postIndex + 1} sur ${maxPosts}.`,
}

export default lang
